module.exports = __webpack_public_path__ + "assets/arrow.93881d6b.svg";